import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9d88bd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "输入数量", -1 /* HOISTED */))
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "物料", -1 /* HOISTED */))
const _hoisted_7 = { class: "value code" }
const _hoisted_8 = {
  key: 0,
  class: "info-row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前库存", -1 /* HOISTED */))
const _hoisted_10 = { class: "value highlight" }
const _hoisted_11 = {
  key: 1,
  class: "info-row"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "最大数量", -1 /* HOISTED */))
const _hoisted_13 = { class: "value highlight" }
const _hoisted_14 = {
  key: 2,
  class: "input-group batch-group"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "批次号", -1 /* HOISTED */))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "qtyInput" }, "数量", -1 /* HOISTED */))
const _hoisted_19 = { class: "qty-input-wrapper" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["min", "max", "onKeyup"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 3,
  class: "error-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dialog-overlay",
    onClick: _withModifiers($setup.handleCancel, ["self"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "dialog-header" }, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "close-btn",
          onClick: $setup.handleCancel
        }, "✕")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString($props.item?.item_code), 1 /* TEXT */)
        ]),
        ($props.item?.current_qty !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString($props.item.current_qty), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($props.maxQty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString($props.maxQty), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" 批次号选择（盘点模式下有批次的物料） "),
        ($setup.showBatchSelect)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              ($props.item?.available_batches?.length)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.selectedBatch) = $event)),
                    class: "batch-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.available_batches, (b) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: b,
                        value: b
                      }, _toDisplayString(b), 9 /* TEXT, PROPS */, _hoisted_16))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */)), [
                    [_vModelSelect, $setup.selectedBatch]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.selectedBatch) = $event)),
                    type: "text",
                    class: "batch-input",
                    placeholder: "请输入批次号"
                  }, null, 512 /* NEED_PATCH */)), [
                    [_vModelText, $setup.selectedBatch]
                  ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "qty-btn",
              onClick: $setup.decrement,
              disabled: $props.allowZero ? $setup.qty <= 0 : $setup.qty <= 1
            }, "-", 8 /* PROPS */, _hoisted_20),
            _withDirectives(_createElementVNode("input", {
              id: "qtyInput",
              ref: "inputRef",
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.qty) = $event)),
              min: $props.allowZero ? 0 : 1,
              max: $props.maxQty,
              step: "1",
              class: "qty-input",
              onKeyup: _withKeys($setup.handleConfirm, ["enter"])
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21), [
              [
                _vModelText,
                $setup.qty,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              class: "qty-btn",
              onClick: $setup.increment,
              disabled: $props.maxQty && $setup.qty >= $props.maxQty
            }, "+", 8 /* PROPS */, _hoisted_22)
          ])
        ]),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", { class: "dialog-footer" }, [
        _createElementVNode("button", {
          class: "dialog-btn cancel",
          onClick: $setup.handleCancel
        }, "取消"),
        _createElementVNode("button", {
          class: "dialog-btn confirm",
          onClick: $setup.handleConfirm
        }, "确认")
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}